import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import ReBox from "../../../../common/ReBox";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../common/Context";
import { green, purple, white } from "../../../../../theme/colours";
import { TotalIcon } from "../../../../common/Icons";

const PlacedTeamDisplay = ({ name, score, icon, index, isActive }) => {
  const { t } = useTranslation("SafeRoads");
  const { tabletView, mobileView, desktopView } = useContext(GlobalContext);

  const containerStyle = {
    p: mobileView ? "2rem 0 2rem 6rem" : "1%",
    pt: mobileView ? "2rem" : tabletView ? "3.5rem" : "2.5rem",
    mr: !mobileView && "1rem",
    mb: mobileView && "1rem",
    boxShadow: "0px 5px 15px 2px #DAD8E8",
    background:
      isActive && `linear-gradient(151deg, ${purple[1]} 0%, ${green[1]} 100%)`,
    backgroundColor: white,
    display: "flex",
    flexDirection: !mobileView && "column",
    alignItems: "center",
  };
  const scoreDisplayAreaStyle = {
    display: "flex",
    justifyContent: !mobileView && "center",
  };
  const iconStyle = {
    width: mobileView || tabletView ? "25px" : "23px",
    height: "auto",
    fill: isActive ? white : green[2],
  };
  const placementBoxStyle = {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: mobileView ? "50%" : "0",
    left: mobileView ? "calc(-1% + 50px)" : `50%`,
    width: desktopView || mobileView ? "50px" : "60px",
  };
  const noIconStyle = {
    borderRadius: "50%",
    width: desktopView ? "50px" : "55px",
    height: desktopView ? "50px" : "55px",
    backgroundColor: "#E7E7E7",
    margin: !mobileView && "0 auto",
    boxShadow: !isActive && "#DAD8E8 0px 3px 4px 1px",
    border: `3px solid ${isActive ? "#B7CDFA" : "transparent"}`,
  };
  const nameStyle = {
    fontSize: "0.875rem",
    fontWeight: 700,
    textAlign: !mobileView && "center",
    m: `${mobileView ? 0 : 1}rem 0 0.5rem`,
    color: isActive && white,
    overflowWrap: "anywhere",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    textOverflow: "ellipsis",
    overflow: "hidden",
    lineHeight: 1.25,
  };
  const scoreStyle = {
    color: isActive ? white : green[2],
    fontWeight: 700,
    fontSize: "0.875rem",
    ml: "0.375rem",
  };
  const bottomTextStyle = {
    ml: mobileView && "1.5rem",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "space-between",
  };

  return (
    <ReBox style={containerStyle}>
      <Box
        sx={placementBoxStyle}
        component="img"
        alt={t("medalDesc")}
        src={
          index === 0
            ? "/images/safeRoads/FirstPlace.svg"
            : index === 1
            ? "/images/safeRoads/SecondPlace.svg"
            : "/images/safeRoads/ThirdPlace.svg"
        }
      />
      {icon ? (
        <img alt={t("teamicon")} src={icon} width="75px" />
      ) : (
        <Box sx={noIconStyle} />
      )}
      <Box sx={bottomTextStyle}>
        <Typography sx={nameStyle}>{name}</Typography>
        <Box sx={scoreDisplayAreaStyle}>
          <TotalIcon style={iconStyle} />
          <Typography sx={scoreStyle}>{score || "-"}</Typography>
        </Box>
      </Box>
    </ReBox>
  );
};

export default PlacedTeamDisplay;
